/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartItemMicrosoft365AddResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest, serializeWebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse, type WebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest, type WebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse } from '../../../models/index.js';
// @ts-ignore
import { type WithCartItemItemRequestBuilder, WithCartItemItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/microsoft-365
 */
export interface Microsoft365RequestBuilder extends BaseRequestBuilder<Microsoft365RequestBuilder> {
    /**
     * Gets an item from the OrderApiClient.cart.item.microsoft365.item collection
     * @param cartItemId Unique identifier of the item
     * @returns {WithCartItemItemRequestBuilder}
     */
     byCartItemId(cartItemId: string) : WithCartItemItemRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse>}
     */
     post(body: WebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartItemMicrosoft365AddResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: WebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const Microsoft365RequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/microsoft-365";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const Microsoft365RequestBuilderNavigationMetadata: Record<Exclude<keyof Microsoft365RequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCartItemId: {
        requestsMetadata: WithCartItemItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["cartItemId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const Microsoft365RequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: Microsoft365RequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartItemMicrosoft365AddResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartItemMicrosoft365AddRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
